
import { useEffect, useState } from "react";
import { styled, Theme, CSSObject } from "@mui/material/styles";
import { NavLink } from "react-router-dom";
import {
  IdCard,
  X,
  LayoutDashboard,
  UserRoundCog,
  Contact,
  LayoutPanelTop,
  FileUser,
  UserPlus,
  Users,
  Building2,
  CheckCircle,
  ClipboardList,
  Ship,
  Plane,
  Tag,
  File,
  Activity,

  LineChart,
  MapPinned,
  Shield,
  Webhook,

  TrendingUp,

  Bookmark,
  ListTree,
  Bug,
  RotateCcw,
  FileText,
  CreditCard,
} from "lucide-react";
import { Outlet } from "react-router-dom";
import {
  Box,
  Toolbar,
  IconButton,
  Drawer as MuiDrawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  useMediaQuery,
  CssBaseline,
  Tooltip,
  Badge,
} from "@mui/material";
import { Menu as MenuIcon, Logout as LogoutIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CreditVisibility from "./useCreditVisibility";
import { getAllowedRoutes } from "../../utility/constant";
import { useRole } from "../MangeContextProvide";

const drawerWidth = 265;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function SideNav(props: any) {
  const isMobile = useMediaQuery("(max-width:991px)");
  const { role, module, isWebhookAllowed }: any = useRole();
  const navigate = useNavigate();
  const [clickedItem, setClickedItem] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);

  const modules = module || [];
  const showWAAndAWBCredits = modules.includes("1");
  const [openGroup, setOpenGroup] = useState<string | null>(null);

  const handleGroupClick = (groupName: string) => {
    setOpenGroup((prev) => (prev === groupName ? null : groupName));
  };
  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const email = localStorage.getItem("email");
  const [isActive, setIsActive] = useState(false);

  const handleToggle = () => {
    setIsActive((prev) => !prev);
  };

  const sideBarItems = [
    {
      name: "Dashboard",
      icon: (
        <Badge badgeContent={props.unreadCount} max={999} color="primary">
          <LayoutDashboard className="text-center" />
        </Badge>
      ),
      url: "/tracking-management",
    },

    {
      name: "Manage Profile",
      icon: <UserRoundCog />,
      url: "/manage-profile",
    },
    {
      name: "Manage Contacts",
      icon: <Contact />,
      url: "/manage-contact",
    },
    ...(email === "kashish.sharma@skyways-group.com"
      ? [
        {
          name: "Document Automation",
          icon: <File />,
          url: "/document_automation",
        },
      ]
      : []),
    ...(email === "kashish.sharma@skyways-group.com"
      ? [
        {
          name: "Tracking Simulator",
          icon: <Activity />,
          url: "/tracking-simulator",
        },
      ]
      : []),



    {
      name: "Manage Users",
      icon: <UserPlus />,
      url: "/manage-users",
    },
    {
      name: "Manage Communication",
      icon: <ClipboardList />,
      url: "/manage-communication",
    },
    {
      name: "Add Organisation",
      icon: <Building2 />,
      url: "/add-organization",
    },
    {
      name: "Subscription Template",
      icon: <LayoutPanelTop />,
      url: "/subscription-template",
    },
    {
      name: "Manage Teams",
      icon: <Users />,
      url: "/manage-teams",
    },

    {
      name: "Manage Tags",
      icon: <Tag />,
      url: "/manage-tags",
    },
    {
      name: "Archiving Management",
      icon: <LineChart />,
      url: "/archive-management",
    }
    ,
    {
      name: "Milestone Management",
      icon: <ListTree />,
      url: "/milestone-management",
    },
    {
      name: "Manage Milestone Grouping",
      icon: <MapPinned />,
      url: "/manage-milestone-grouping",
    },
    {
      name: "Manage Flags",
      icon: <Bookmark />,
      url: "/manage-flags",
    },
    {
      name: "Manage Custom Fields",
      icon: <FileUser />,
      url: "/manage-custom-fields",
    },
    {
      name: "Communication Template",
      icon: <LayoutPanelTop />,
      url: "/communication-template",
    },

    ...(isWebhookAllowed
      ? [
        {
          name: "Milestone Webhooks",
          icon: <Webhook />,
          url: "/milestone-webhooks",
        }
      ]
      : [])

    ,
    {
      name: "Usage Metrics",
      icon: <LineChart />,
      url: "/usage-metrics",
    }
    ,
    {
      name: "Communication Errors",
      icon: <Bug />,
      url: "/communication-errors",
    },
    {
      name: "Failed Tracking",
      icon: <RotateCcw />,
      url: "/failed-tracking",
    },
    {
      name: "Report",
      icon: <FileText />,
      url: "/report",
    },

  ];


  const customerAdminSidebar = [
    {
      type: "item",
      name: "Dashboard",
      icon: (
        <Badge badgeContent={props.unreadCount} max={999} color="primary">
          <LayoutDashboard className="text-center" />
        </Badge>
      ),
      url: "/tracking-management",
    },
    {
      type: "item",
      name: "Manage Profile",
      icon: <UserRoundCog />,
      url: "/manage-profile",
    },
    {
      type: "group",
      name: "Admin",
      icon: <Shield />,
      children: [
        { name: "Manage Users", icon: <UserPlus />, url: "/manage-users" },
        { name: "Manage Teams", icon: <Users />, url: "/manage-teams" },
        { name: "Archiving Management", icon: <LineChart />, url: "/archive-management" },
        { name: "Milestone Management", icon: <ListTree />, url: "/milestone-management" },
        { name: "Manage Milestone Grouping", icon: <MapPinned />, url: "/manage-milestone-grouping" },
        { name: "Manage Flags", icon: <Bookmark />, url: "/manage-flags" },
        { name: "Manage Custom Fields", icon: <FileUser />, url: "/manage-custom-fields" },
        { name: "Communication Template", icon: <LayoutPanelTop />, url: "/communication-template" },
        ...(isWebhookAllowed ? [{ name: "Webhook Config", icon: <Webhook />, url: "/milestone-webhooks" }] : []),
        { name: "Usage Metrics", icon: <TrendingUp />, url: "/usage-metrics" },
        { name: "Communication Errors", icon: <Bug />, url: "/communication-errors" },
        { name: "Report", icon: <FileText />, url: "/report" },

      ],
    },
    {
      type: "group",
      name: "User",
      icon: <Users />,
      children: [
        { name: "Manage Contacts", icon: <Contact />, url: "/manage-contact" },
        { name: "Subscription Template", icon: <LayoutPanelTop />, url: "/subscription-template" },
        { name: "Manage Subscription", icon: <ClipboardList />, url: "/manage-communication" },
      ],
    },
  ];

  const allowedRoutes = getAllowedRoutes({
    role,
    isWebhookAllowed: isWebhookAllowed,
  });

  const filteredItems = sideBarItems.filter((item) =>
    allowedRoutes.includes(item.url)
  );


  const finalSidebar =
    role === "customeradmin" ? customerAdminSidebar : filteredItems;


  useEffect(() => {
    if (filteredItems.length > 0) {
      setClickedItem(filteredItems[0].name);
    }
  }, [filteredItems]);

  useEffect(() => {
    setIsActive(false);
  }, [isMobile]);

  return (
    <>
      <Box
        className={isActive ? "sidemenuopen" : "inactive"}
        sx={{ display: "flex", height: "100vh", overflow: "hidden" }}
      >
        <CssBaseline />
        <Drawer className="sidemenu" variant="permanent" open={isActive}>
          <div className="mobilename">
            <h4>Menu</h4>
            <i className="closemenu" onClick={handleToggle}>
              <X />
            </i>
          </div>
          <DrawerHeader></DrawerHeader>
          <Divider />


          <List>
            {finalSidebar.map((item: any) => {
              if (item.type === "group") {
                return (
                  <div key={item.name}>
                    <ListItem disablePadding>
                      <Tooltip title={!isActive ? item.name : ""} placement="right" arrow>
                        <ListItemButton onClick={() => handleGroupClick(item.name)}>
                          <ListItemIcon>{item.icon}</ListItemIcon>
                          <p> <ListItemText primary={item.name} /></p>
                        </ListItemButton>
                      </Tooltip>
                    </ListItem>

                    {openGroup === item.name &&
                      item.children.map((child: any) => (
                        <ListItem key={child.name} disablePadding sx={{ pl: 3 }}>
                          <Tooltip title={!isActive ? child.name : ""} placement="right" arrow>
                            <ListItemButton
                              component={NavLink}
                              to={child.url}
                              sx={{
                                "&.active": {
                                  backgroundColor: "rgba(25, 118, 210, 0.12)",
                                  color: "#1976d2",
                                },
                                "&:hover": {
                                  backgroundColor: "rgba(25, 118, 210, 0.08)",
                                },
                              }}
                            >
                              <ListItemIcon>{child.icon}</ListItemIcon>
                              <p><ListItemText primary={child.name} /></p>
                            </ListItemButton>
                          </Tooltip>
                        </ListItem>
                      ))}

                    <Divider sx={{
                      my: 1, borderColor: "rgba(255,255,255,0.1)", marginTop: "0px",
                      marginBottom: "0px "
                    }} />
                  </div>
                );
              }

              // Normal Item
              return (
                <ListItem key={item.name} disablePadding>
                  <Tooltip title={!isActive ? item.name : ""} placement="right" arrow>
                    <ListItemButton
                      onClick={() => handleGroupClick(item.name)}
                      component={NavLink}
                      to={item.url}
                      sx={{
                        "&.active": {
                          backgroundColor: "rgba(25, 118, 210, 0.12)",
                          color: "#1976d2",
                        },
                        "&:hover": {
                          backgroundColor: "rgba(25, 118, 210, 0.08)",
                        },
                      }}
                    >
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <p><ListItemText primary={item.name} /></p>
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              );
            })}
          </List>

        </Drawer>

        <div
          className="dashRight"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            overflow: "hidden",
            flex: 1,
            minWidth: 0,
          }}
        >
          <div
            style={{
              flexShrink: 0,
              zIndex: 1100,
              background: "#fff",
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            }}
          >
            <div className="dashHeader grid grid-cols-12 items-center">
              {/* Left: menu + logo */}
              <div className="2xl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-6">
                <Toolbar>
                  <IconButton onClick={handleToggle}>
                    <MenuIcon />
                  </IconButton>
                  <div className="dashlogo">
                    <img src="/images/logo.png" alt="" />
                  </div>

                  <IconButton
                    color="inherit"
                    edge="start"
                    onClick={toggleDrawer}
                    sx={{ marginRight: 2 }}
                  ></IconButton>
                </Toolbar>
              </div>

              {/* Right: credits + logout grouped together (removes the gap) */}
              <div className="2xl:col-span-9 xl:col-span-9 lg:col-span-9 md:col-span-9 col-span-6 flex items-center justify-end gap-3 flex-wrap">
                {role !== "admin" && (
                  <div className="editdashboard">
                    <div className="headerCustomeBox flex justify-end">
                      <div className="pt-0 mt-0 w-full md:w-auto">
                        <div className="md:flex grid grid-cols-12 gap-2 lg:gap-5 md:gap-5 sm:gap-5">

                          {showWAAndAWBCredits && (
                            <div className="col-span-6">
                              <div className="flex Editiconsize">
                                <figure className="shape justify-center flex mr-2">
                                  <CreditCard className="text-lg text-[#f5a623] w-[30px] h-[28px] mt-[5px]" />
                                </figure>
                                <aside className="leading-[14px]">
                                  <span className="text-xs">credits</span>
                                  <h6 className="text-xs text-gray-600 lg:text-right text-left">
                                    <CreditVisibility air="air" />
                                  </h6>
                                </aside>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="hlogout flex justify-end">
                  <ListItemButton onClick={handleLogout}>
                    <ListItemIcon>
                      <LogoutIcon />
                    </ListItemIcon>
                  </ListItemButton>
                </div>
              </div>
            </div>
          </div>

          <Box
            className="dashArea"
            component="main"
            sx={{ flexGrow: 1, p: 3, overflowY: "auto", minHeight: 0 }}
          >
            <Outlet />
          </Box>
        </div>
      </Box>
    </>
  );
}